import { Component, Prop, Vue } from 'vue-property-decorator'
import Container from 'typedi'
import router from '@/bootstrap/router/router'
import store from '@/bootstrap/store/store'
import SecurityContext from '@/modules/common/services/security-context.service'
import { MediaStoreUploadResult } from '@/interfaces'

@Component({
  name: 'GtrTextEditor'
})
export default class GtrTextEditor extends Vue {
    @Prop({ required: false, type: String, default: '' })
    label: string|undefined

    @Prop({ required: false, type: Object, default: null })
    setting: object | undefined

    @Prop({ required: false, type: String, default: '' })
    value: string|undefined

    @Prop({ required: true, type: String, default: '' })
    event_uuid: string|undefined

    @Prop({ required: false, type: Boolean, default: false })
    readonly: boolean|undefined

    data () {
      return {
        loading: true,
        editor: null,
        config: {
          height: 200,
          key: 'yDC5hG4I4A10D6B5F6gKTRe1CD1PGb1DESAb1Kd1EBH1Pd1TKoD6C5G5G4G2C3H3B4A5B5',
          model: '',
          imageManagerLoadURL: `${process.env.VUE_APP_API_URL}event/${this.event_uuid}/media?formatForFroala=1`,
          imageManagerLoadMethod: 'GET',
          requestWithCORS: false,
          fileUploadURL: `${process.env.VUE_APP_API_URL}event/${this.event_uuid}/media?formatForFroala=1`,
          imageMaxSize: 2 * 1024 * 1024,
          fileMaxSize: 500 * 1024 * 1024,
          requestHeaders: {
            authorization: `Bearer ${this.getToken()}`
          },
          toolbarButtons: {
            moreText: {
              buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'clearFormatting']
            },
            moreParagraph: {
              buttons: ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
            },
            moreRich: {
              buttons: ['insertLink', 'insertImage', 'insertTable', 'emoticons', 'specialCharacters', 'insertFile', 'insertHR']
            },
            moreMisc: {
              buttons: ['undo', 'redo', 'fullscreen', 'print', 'selectAll', 'html', 'help'],
              align: 'right',
              buttonsVisible: 2
            }
          },
          events: {
            initialized: this.makeReadonly(),
            'image.beforeUpload': (files: File[]) => { this.uploadImage(files); return false },
            'file.beforeUpload': (files: File[]) => { this.uploadFile(files); return false }
          }
        }
      }
    }

    makeReadonly () {
      if (this.readonly) {
        return function (this: any) {
          this.edit.off()
        }
      }
      return null
    }

    private getToken () {
      return Container.get(SecurityContext).token()
    }

    get localValue () {
      return this.value
    }

    set localValue (localValue) {
      this.$emit('input', localValue)
    }

    mounted () {
      this.$data.loading = false
    }

    get mergedConfig () {
      return {
        ...this.$data.config,
        ...this.setting
      }
    }

    async uploadImage (files: File[]) {
      const editorWrapper = this.$refs.textEditor as any
      const editor = editorWrapper.getEditor()
      this.$store.dispatch('common/showLoader', { value: true })

      const response: MediaStoreUploadResult[] = await store.dispatch('media/uploadMedia', { event_uuid: router.currentRoute.params.event_uuid, files })
      response.forEach(file => {
        const safeUrl = encodeURI(file.url)
        editor.events.focus(true) // Insert at current selection; use true to refresh at cursor
        editor.image.insert(safeUrl, true, null, editor.image.get(), null)
      })

      this.$store.dispatch('common/hideLoader')
      return false
    }

    async uploadFile (files: File[]) {
      const editorWrapper = (this.$refs.textEditor as any)
      const editor = editorWrapper.getEditor()
      this.$store.dispatch('common/showLoader', { value: true })

      const response: MediaStoreUploadResult[] = await store.dispatch('media/uploadMedia', { event_uuid: router.currentRoute.params.event_uuid, files })
      response.forEach(file => {
        const safeUrl = encodeURI(response[0].url)
        const filename = response[0].url.substring(response[0].url.lastIndexOf('/') + 1) || 'file'
        editor.events.focus(true) // Insert at current selection; use true to refresh at cursor
        editor.file.insert(safeUrl, filename)
      })

      this.$store.dispatch('common/hideLoader')
      return false
    }
}
